import { MenuNode } from '../submodules/angular-ui-common/base-types';
import { BASE_NAVIGATION_TREE } from '../submodules/angular-ui-common/navigation-tree';

export const NAVIGATION_TREE: MenuNode[] = [
  ...BASE_NAVIGATION_TREE, 
  {
    id: "mission",
    shortLabel: "Mission",
    label: "Mission",
    url: '/home#mission',
    requiredAuthorities: [],
    disabled: false,
    showInPublicMenu: true,
    showInPrivateMenu: true,
    navigable: true
  }, {
    id: "services",
    shortLabel: "Servizi",
    label: "Servizi",
    url: '/home#services',
    requiredAuthorities: [],
    disabled: false,
    showInPublicMenu: true,
    showInPrivateMenu: true,
    navigable: true
  }, {
    id: "team",
    shortLabel: "Team",
    label: "Team",
    url: '/home#team',
    requiredAuthorities: [],
    disabled: false,
    showInPublicMenu: true,
    showInPrivateMenu: true,
    navigable: true
  }, {
  //   id: "cookie_policy",
  //   shortLabel: "MENU.COOKIE_POLICY",
  //   label: "MENU.COOKIE_POLICY",
  //   url: '/cookie-policy',
  //   requiredAuthorities: [],
  //   disabled: false,
  //   showInPublicMenu: true,
  //   showInPrivateMenu: true,
  //   navigable: true
  // }, {
    id: "form",
    shortLabel: "PRENOTA PROVA",
    label: "PRENOTA PROVA",
    url: '/home#form',
    requiredAuthorities: [],
    disabled: false,
    showInPublicMenu: false,
    showInPrivateMenu: false,
    navigable: true
  },
  {
    id: "reservation",
    shortLabel: "MENU.RESERVATION",
    label: "MENU.RESERVATION",
    url: '/private/home',
    requiredAuthorities: [],
    disabled: false,
    showInPublicMenu: false,
    showInPrivateMenu: false,
    navigable: true
  // }, {
  //   id: "how_to_intervene",
  //   shortLabel: "MENU.HOW_TO_INTERVENE",
  //   label: "MENU.HOW_TO_INTERVENE",
  //   url: '/how-to-intervene',
  //   requiredAuthorities: [],
  //   disabled: false,
  //   showInPublicMenu: false,
  //   showInPrivateMenu: false,
  //   navigable: true
  }
];
